<template>
  <div id="user">
    <el-container class="container " :style="{height:containerHeight}">
      <el-main class="main">
        <div class="main-in">
          <p class="title">修改密码</p>
          <template v-if="type===0">
            <div class="steps">
              <el-steps :active="1" finish-status="success" process-status="wait" :align-center="true">
                <el-step title="修改密码" class="verification" status="process"></el-step>
                <el-step title="密码找回"></el-step>
              </el-steps>
              <div style="width: 390px;margin:40px auto 0 auto;">
                <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="82px" label-position="left">
                  <el-form-item label="旧密码：" prop="oldPassword">
                    <el-input type="password" v-model="passwordForm.oldPassword" placeholder="请输入">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="新密码：" prop="newPassword">
                    <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="确认密码：" prop="conPassword">
                    <el-input type="password" v-model="passwordForm.conPassword" placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </el-form>
                <a style="margin-left:82px" class="tab-programme-b" href="javascript:;" @click="next">下一步</a>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="steps">
              <el-steps :active="2" finish-status="success" process-status="wait" :align-center="true">
                <el-step title="修改密码" class="verification"></el-step>
                <el-step title="修改完成" status="process"></el-step>
              </el-steps>
            </div>
            <div style="text-align:center;margin-top:40px">
              <img style="wdith:72px;height:72px;" src="https://img.deepbaytech.com/images2021/complete.png" alt="">
              <p style="margin-top:24px;font-size: 24px;font-weight: 500;color: rgba(0, 0, 0, 0.85);">
                操作成功</p>
            </div>
          </template>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    var validateOldPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      }
      else {
        callback()
      }
    }
    var validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      }
      else {
        if (value === this.passwordForm.oldPassword) {
          callback(new Error('新密码和旧密码一致'))
        }
        callback()
      }
    }
    var validateConPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      type: 0,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        conPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { validator: validateOldPassword, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        conPassword: [
          { validator: validateConPassword, trigger: 'blur' }
        ],

      },
      containerHeight: null
    }
  },
  created () {
    this.containerHeight = document.body.clientHeight - 104 + 'px'
  },
  methods: {
    next () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.type = 1
        }
      })
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  background-color: #f5f5f5;
  height: 100vh;
}
.main-in {
  background-color: #fff;
  padding: 24px 24px 30px 24px;
}
.title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 40px;
}
.key {
  display: inline-block;
  width: 122px;
  height: 22px;
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
}
::v-deep .el-form-item__label {
  color: #000;
}
.steps {
  width: 570px;
  margin: auto;
}
::v-deep .el-step {
  left: -38px;
}
::v-deep .el-step__head.is-process .el-step__icon.is-text {
  position: relative;
  background: #77ba00;
  color: #fff;
  border: none;
  font-size: 16px;
  width: 32px;
  height: 32px;
}
::v-deep .el-step__icon.is-text {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-step__title {
  position: absolute;
  left: 170px;
  top: -4px;
}
::v-deep .el-step.is-center .el-step__line {
  position: absolute;
  left: 240px;
  top: 14px;
  width: 160px;
  height: 1px;
  background: #77ba00;
}
.tab-programme-b {
  display: inline-block;
  width: 74px;
  height: 32px;
  background: #77ba00;
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
}
::v-deep .verification .el-step__icon.is-text {
  border: 1px solid #77ba00;
}
::v-deep .verification .el-step__title.is-success {
  color: #c0c4cc;
  font-size: 16px;
}
::v-deep .el-input__inner {
  width: 320px;
  height: 32px;
  border-radius: 0%;
}
</style>
